import GLightbox from 'glightbox';

const lightbox = GLightbox({
  selector:'*[data-glightbox]'
});
